var escape = require("../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.tabActive[data-v-6387e0f2] {\n    background-color: #12bcf1;\n    color: white;\n}\n.new-button.pull-right[data-v-6387e0f2] {\n    width: 125px;\n    margin-right: 0px;\n}\n@media (max-width: 768px) {\n.toolbarPageBottomBlank[data-v-6387e0f2] {\n      height: 75px !important;\n}\n}\n@media (min-width: 993px) {\n.searchForm[data-v-6387e0f2] {\n      margin-top: 0%;\n}\n.heightifLargeScreen[data-v-6387e0f2] {\n      overflow-y: auto;\n      height: 105%;\n}\n.contactButtonContainer[data-v-6387e0f2] {\n      margin-top: 0% !important;\n      margin-left:0px\n}\n}\n.rowBackgroundImage[data-v-6387e0f2] {\n  background-image: url(" + escape(require("../../../assets/static/images/MenuFont.png")) + ");\n  background-size: contain;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6387e0f2","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/services/directPayments/SendboxPage.vue
// module id = 1144
// module chunks = 2